import AdminWorker from './admin';
import ClientWorker from './client';

const tenants = {
    admin: AdminWorker,
    client: ClientWorker
};

export default tenants;



// WEBPACK FOOTER //
// ./src/pages/worker/tenants/index.jsx